import React, { useState, useEffect, useRef } from "react";
import Draggable from 'react-draggable';
import Navbar from "../../components/common/Navbar";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelOcho.scss";

import hook from "../../assets/images/home/hook.svg";
import payload from "../../assets/images/home/payload.svg";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

function LevelOcho() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [down, setDown] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    totalTime: 0,
    totalHints: 0,
  });
  const [timer, setTimer] = useState(0);
  const divRef = useRef()

  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  const trackPos = (data) => {
    let rect1 = document.getElementsByClassName('hook')[0].getBoundingClientRect();
    let rect2 = document.getElementsByClassName('box')[0].getBoundingClientRect();
    var overlap = !(rect1.right < (rect2.left + 80) ||
      rect1.left > (rect2.right - 80) ||
      rect1.bottom < (rect2.top + 20) ||
      (rect1.top + 88) > (rect2.bottom - 219))
    if (overlap) {
      setDisabled(true);
      setDown(true);
      const finalObj = {
        gameData: {
          levelData: [
            {
              level: 6,
              levelName: 'Hangman',
              totalTime: timer,
              isLevelCleared: true,
              isLevelSkipped: false,
              totalHintsTaken: localStorage.getItem("totalHints"),
              timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
              timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
            }
          ],
        }
      }
      console.log(finalObj)
      sendResult(finalObj)
      setWon(true);
    }
  };

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        setMove(true);
      }
    }, 3000);
  }, [won]);

  return (
    <div>
      <div className="component-level-ocho">
        {move && <LevelComplete levelNum={3} />}
        <Navbar won={won} levelNum={3} />
        <div className={"container " + (down ? "drowned " : "") + (disabled ? "disable " : "")}>
          <div className={"curtain "}>
            <div className="hook"><img src={hook} alt={hook} /></div>
          </div>
          <Draggable isDragDisabled={disabled} disabled={disabled} onMouseDown={(e) => { e.stopPropagation() }} bounds="parent" onStop={(e, data) => trackPos(data)}>
            <div className={"box "}><img className={down ? 'swing' : ''} src={payload} alt={payload} /></div>
          </Draggable>
        </div>
      </div>
    </div>
  )
}

export default LevelOcho
